import { sha256 } from 'js-sha256';
import Base64 from './base64';

// Escape base64 encoding into base64url encoding. Learn more: https://stackoverflow.com/a/55389212/4183985
const escape = (str: string) => str.replace(/\+/g, '-').replace(/\//g, '_');

const sign = (input: string, key: string) => escape(
  Base64.stringify(sha256.hmac.digest(key, input) as unknown as Uint8Array, { pad: false }),
);

export default (payload: object, key: string) => {
  const header = { alg: 'HS256', typ: 'JWT' };

  const segments = [];
  segments.push(Base64.stringify(JSON.stringify(header), { pad: false }));
  segments.push(Base64.stringify(JSON.stringify({
    ...payload,
    iat: Math.round((+new Date()) / (1000 * 60 * 30)), // refresh after 30 minutes
  }), { pad: false }));
  segments.push(sign(segments.join('.'), key));
  return segments.join('.');
};
